export const THEMES = {
  DARK: "dark",
  LIGHT: "light",
} as const;

export const THEME_CLASSES = {
  [THEMES.DARK]: "proton-ui__theme--dark",
  [THEMES.LIGHT]: "proton-ui__theme--light",
};